// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/images/hero-banner-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../Assets/images/border-shape.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Home page */

/* Hero section */
.items-slide {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: 170px 0 420px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.hero-inner h1 {
  font-size: 72px;
  color: #fff;
  font-weight: 600;
  margin: 0 0 30px;
}
.hero-slider ul.slick-dots {
  bottom: auto;
  right: 0;
  width: 40px;
  top: 50%;
}

.hero-slider .slick-dots li button:before {
  font-size: 15px;
  opacity: 0.5;
  color: #5c58fc !important;
}

.hero-slider .slick-dots li.slick-active button:before {
  opacity: 1;
}
.hero-main {
  position: relative;
}

.hero-slider {
  margin: 0 !important;
}
.hero-inner p {
  font-size: 26px;
  line-height: 38px;
  color: #fff;
  max-width: 620px;
}

.hero-counter {
  background-color: #5c58ff;
  border-radius: 12px;
  padding: 50px 20px;
  max-width: 1100px;
  margin: 0 auto 0;
  position: absolute;
  left: 15px;
  right: 15px;
  bottom: 80px;
}
.column-3 {
  width: 25%;
  padding: 0 15px;
}

.hr-count {
  text-align: center;
}

.hr-count h2 {
  color: #fff;
  font-size: 50px;
  font-weight: 700;
  line-height: 66px;
  margin: 0 0 10px;
}

.hr-count p {
  color: #fff;
  font-size: 20px;
  line-height: 31px;
}
/* End Hero section */

/* Plateform section */
.platform-section {
  padding: 170px 0 85px;
  text-align: center;
  position: relative;
}
.platform-section::before {
  content: "";
  width: 4px;
  background-color: #1e73be;
  height: 135px;
  position: absolute;
  top: -15px;
}
.platform-inner p,
.platform-inner h3 {
  font-size: 30px;
  line-height: 42px;
  font-weight: 300;
}
.platform-inner {
  max-width: 1050px;
  margin: 0 auto;
}
/* End Plateform section */

/* Citizen section */
.citizen-section {
  background-color: #4ac193;
}

.citizen-section .row {
  margin: 0;
}

.citizen-section .col6 {
  padding: 0;
}

.citizen-left h6 {
  font-size: 18px;
  line-height: 22px;
  font-weight: 300;
  color: #fff;
}

.citizen-left h2 {
  font-size: 45px;
  line-height: 55px;
  color: #fff;
  margin: 10px 0;
}

.citizen-left p {
  font-size: 23px;
  line-height: 38px;
  color: #fff;
  font-weight: 300;
}

.citizen-left {
  padding: 18% 17%;
}

.citizen-right img {
  display: block;
  width: 100%;
}

.citizen-box {
  background-color: #5c58fc;
  width: 100%;
  padding: 15px 40px;
}

.citizen-right {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}

.citizen-box .row {
  align-items: center;
  height: 100%;
}

.citizen-bx-inner {
  text-align: center;
  padding: 18px 0;
}

.citizen-bx-inner p {
  font-size: 23px;
  line-height: 27px;
  color: #fff;
}

.citizen-bx-inner {
  border-right: 1px solid rgb(255 255 255 / 20%);
}

.citizen-box .col6:last-child .citizen-bx-inner {
  border-right: none;
}
/* End Citizen section */

/* Digital section */
.digital-section {
  padding: 110px 0;
}

.sc-title {
  text-align: center;
}

.sc-title h3 {
  font-size: 36px;
  line-height: 47px;
  font-weight: 400;
  margin: 0 0 15px;
}

.sc-title p {
  font-size: 30px;
  line-height: 49px;
  font-weight: 300;
}

.dil-grid {
  text-align: center;
  width: 33.3%;
  padding: 15px 15px;
  margin: 30px 0;
}

.dil-grid p {
  font-size: 25px;
  line-height: 40px;
  font-weight: 300;
}

.dil-grid img {
  width: 37px;
  margin: 0 auto;
}

.digital-grid {
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0 0;
}

.dil-grid:nth-child(4),
.dil-grid:nth-child(5) {
  width: 50%;
}
/* End Digital section */

/* service section */
.service-section .col4 {
  padding: 0;
}

.srv-inner {
  position: relative;
}

.srv-img img {
  width: 100%;
  display: block;
}

.srv-content {
  position: absolute;
  bottom: 100px;
  text-align: center;
  right: 0;
  left: 0;
  padding: 0 20px;
}

.srv-content h6 {
  color: #fff;
  font-weight: 300;
  font-size: 12.2px;
  text-shadow: 1px 1px rgb(0 0 0 / 50%);
}

.srv-content h3 {
  color: #fff;
  font-size: 30px;
  font-weight: 400;
  line-height: 49px;
  margin: 10px 0 20px;
  text-shadow: 1px 1px rgb(0 0 0 / 50%);
}

.fill-button {
  background-color: #5c58fc;
  color: #fff;
  font-size: 16px;
  letter-spacing: 0.5px;
  padding: 10px 20px;
  line-height: normal;
  display: inline-block;
  border-radius: 5px;
}
/* End service section */

/* morden service section */
.morden-service {
  padding: 110px 0 0;
}

.sc-title hr {
  width: 30px;
  border-color: #5c58fc;
  margin-top: 50px;
}

.morden-inner {
  margin-top: 70px;
}

.morden-inner .row {
  margin: 0;
  align-items: center;
}

.morden-inner .col6 {
  padding: 0;
}

.morden-content {
  padding: 40px 21%;
}
.morden-content h2 {
  font-size: 59px;
  line-height: 77px;
  position: relative;
}

.morden-img img {
  display: block;
  width: 100%;
}
.with-shape::before {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  width: 320px;
  height: 10px;
  position: absolute;
  bottom: -10px;
  background-repeat: no-repeat;
  background-size: contain;
}
/* End morden service section */

/* Urban section */
.light-grey-bg {
  background-color: #f6f6f6;
}

.urban-service {
  padding: 90px 0 170px;
}

.urban-title {
  text-align: center;
  max-width: 810px;
  margin: 0 auto 80px;
}

.urban-title img {
  width: 100%;
  max-width: 467px;
}

.urban-title p {
  font-weight: 300;
  font-size: 25px;
  line-height: 40px;
  margin: 40px 0;
}

.urban-img img {
  width: 100%;
  display: block;
}

.urban-content h2 {
  font-size: 31px;
  line-height: 51px;
  font-weight: 300;
}

.urban-content p {
  font-size: 14px;
  line-height: 24px;
  margin: 12px 0;
}
.urban-row .row {
  align-items: center;
}
.urb-rw {
  display: flex;
  flex-wrap: wrap;
}
.urban-row:first-child .urban-img {
  margin-left: -60px;
}

.urban-row:last-child .urban-img {
  margin-right: -60px;
}
.urb-text {
  width: calc(100% - 37px);
  padding: 0 0 0 15px;
}

.urb-icon {
  width: 37px;
}

.urb-text h3 {
  font-size: 24px;
  line-height: 38px;
  font-weight: 300;
}
.urban-row {
  margin: 0 0 30px;
}

.urban-img {
  padding-right: 10px;
}
/* End Urban section */

/* Download app section */
.download-app {
  padding: 90px 0;
}

.download-inner {
  text-align: center;
}

.download-inner h3 {
  font-size: 33px;
  line-height: 53px;
  font-weight: 300;
  margin: 0 0 15px;
}

.buttons-grp {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.buttons-grp a {
  margin: 0 5px;
  padding: 13px 25px;
  border-radius: 5px;
}

.dark-grey-btn {
  background-color: #4c4c4c;
}
/* End Download app section */

/* Opinions section */
.green-bg {
  background-color: #4ac193;
}

.opinions-section {
  padding: 140px 0;
}

.opinions-title {
  text-align: center;
  margin: 0 0 40px;
}

.opinions-title h3 {
  color: #fff;
  font-weight: 300;
  font-size: 39px;
  line-height: 63px;
}

.opinions-title p {
  color: #fff;
}

.opinions-bx {
  background-color: #fff;
  border-radius: 20px;
  padding: 25px;
  margin: 15px;
  width: 34%;
}

.opinions-bx img {
  width: 82px;
}

.opinions-bx p {
  font-size: 16px;
  line-height: 22px;
  font-style: italic;
}

.opinions-inner {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.opinions-bx:nth-child(3),
.opinions-bx:nth-child(4) {
  width: 41%;
}

.opinions-bx:last-child {
  width: 45%;
}
/* End Opinions section */

/* CTC section */
.ctc-section {
  background-color: #5c58fc;
  padding: 65px 0;
}

.ctc-inner {
  text-align: center;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}

.ctc-inner p {
  color: #fff;
  font-size: 25px;
  line-height: 33px;
  font-weight: 300;
  margin: 0 0 40px;
}

.ctc-inner h3 {
  color: #fff;
  font-size: 43px;
  line-height: 56px;
}
.ctc-inner h4 {
  font-size: 34px;
  line-height: 45px;
  color: #fff;
  margin: 0 0 40px;
}

.ctc-inner a {
  background-color: #fff;
  color: #666666;
  font-size: 18px;
  padding: 16px 36px;
  display: inline-block;
  border-radius: 50px;
  vertical-align: middle;
}
.ctc-inner a img {
  display: inline-block;
  vertical-align: middle;
  margin: 0 0 0 8px;
  position: relative;
  top: -2px;
}
/* End CTC section */

/*News section*/
.news-section {
  padding: 80px 0;
}

.news-title {
  text-align: center;
  margin: 0 0 50px;
}

.news-title h2 {
  position: relative;
  font-size: 38px;
  line-height: 50px;
}

.news-title h2::before {
  content: "";
  background-color: rgb(4 4 4 / 10%);
  height: 1px;
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 52%;
  transform: translateY(-50%);
}

.news-title h2 span {
  background-color: #fff;
  padding: 0 10px;
  position: relative;
  z-index: 1;
}
/*end of news*/

/* End Home page */

@media only screen and (max-width: 1440px) {
  /* Home page */
  .hero-inner h1 {
    font-size: 58px;
  }

  .hero-inner p {
    font-size: 22px;
    line-height: 32px;
    max-width: 520px;
  }

  .hr-count h2 {
    font-size: 42px;
    line-height: 58px;
  }

  .hr-count p {
    font-size: 18px;
    line-height: 29px;
  }

  .platform-inner p,
  .platform-inner h3 {
    font-size: 24px;
    line-height: 36px;
  }

  .citizen-left h6 {
    font-size: 16px;
    line-height: 20px;
  }

  .citizen-left h2 {
    font-size: 40px;
    line-height: 50px;
  }

  .citizen-left p {
    font-size: 20px;
    line-height: 33px;
  }

  .sc-title h3 {
    font-size: 30px;
    line-height: 41px;
  }

  .sc-title p {
    font-size: 24px;
    line-height: 38px;
  }

  .dil-grid p {
    font-size: 22px;
    line-height: 36px;
  }

  .srv-content h3 {
    font-size: 24px;
    line-height: 30px;
  }

  .srv-content {
    bottom: 60px;
  }

  .morden-content h2 {
    font-size: 50px;
    line-height: 68px;
  }

  .with-shape::before {
    width: 270px;
  }

  .urban-title p {
    font-size: 22px;
    line-height: 36px;
  }

  .urban-title img {
    max-width: 367px;
  }

  .urban-row:first-child .urban-img {
    margin: 0;
  }

  .urban-row:last-child .urban-img {
    margin: 0;
  }

  .ctc-inner p {
    font-size: 22px;
    line-height: 30px;
  }

  .ctc-inner h3 {
    font-size: 36px;
    line-height: 50px;
  }

  .ctc-inner h4 {
    font-size: 30px;
    line-height: 41px;
  }

  .ctc-inner a {
    font-size: 16px;
  }
  /* End Home page */
}
@media only screen and (max-width: 991px) {
  /* Home page */
  .items-slide {
    padding: 170px 0 280px;
  }

  .hero-counter {
    padding: 30px 15px;
    bottom: 50px;
  }

  .items-slide {
    background-position: right -90px center;
  }
  .platform-section {
    padding: 150px 30px 70px;
  }

  .citizen-section .col6 {
    width: 100%;
  }

  .citizen-left {
    padding: 15% 16%;
  }
  .citizen-box .col6 {
    width: 50%;
  }

  .srv-img img {
    object-fit: cover;
    height: 550px;
  }

  .morden-inner .col6 {
    width: 100%;
  }

  .morden-inner .row {
    flex-direction: column-reverse;
  }

  .morden-content {
    padding: 60px 15%;
  }

  .urban-title img {
    max-width: 311px;
  }

  .urban-row .col6 {
    width: 100%;
  }

  .urban-content {
    padding: 30px 11% 0;
  }

  .urb-icon {
    width: 33px;
  }

  .urb-text {
    width: calc(100% - 33px);
  }

  .urban-row {
    margin: 0 0 0;
  }

  .urban-row:last-child .urban-img {
    padding-left: 11%;
    margin-top: 30px;
  }

  .opinions-bx {
    width: 100% !important;
    max-width: 450px;
  }

  .opinions-section {
    padding: 100px 0;
  }

  .opinions-title h3 {
    margin: 0 0 10px;
  }

  /* End Home page */
}
@media only screen and (max-width: 767px) {
  /* Home page */
  .hero-counter {
    display: none;
  }

  .items-slide {
    padding: 150px 0 50px;
    background-position: right 0px center;
  }

  .hero-inner p {
    max-width: 100%;
    font-size: 18px;
    line-height: 24px;
  }

  .hero-inner h1 {
    font-size: 50px;
    line-height: 50px;
    margin: 0 0 15px;
  }
  .citizen-left {
    padding: 50px 30px;
  }

  .citizen-left h2 {
    font-size: 36px;
    line-height: 46px;
  }

  .citizen-left p {
    font-size: 18px;
    line-height: 29px;
  }

  .citizen-box .col6 {
    width: 100%;
  }

  .citizen-bx-inner {
    border-bottom: 1px solid rgb(255 255 255 / 20%);
    border-right: none;
    padding: 20px 0;
  }

  .citizen-box .col6:last-child .citizen-bx-inner {
    border-bottom: none;
  }

  .citizen-box {
    padding: 15px 20px;
  }

  .citizen-bx-inner p {
    font-size: 18px;
    line-height: 22px;
  }

  .digital-section {
    padding: 60px 0;
  }

  .sc-title h3 {
    font-size: 28px;
    line-height: 37px;
  }

  .sc-title p {
    font-size: 20px;
    line-height: 32px;
  }

  .dil-grid {
    width: 100% !important;
    margin: 20px 0;
  }

  .dil-grid p {
    font-size: 20px;
    line-height: 32px;
  }

  .digital-grid {
    margin-top: 20px;
  }

  .service-section .col4 {
    width: 100%;
  }

  .morden-service {
    padding: 70px 0 0;
  }

  .morden-content {
    padding: 60px 30px;
  }

  .morden-content h2 {
    font-size: 45px;
    line-height: 63px;
  }

  .urban-title img {
    max-width: 186px;
  }

  .urban-service {
    padding: 70px 0 100px;
  }

  .urban-title p {
    font-size: 19px;
    line-height: 30px;
  }

  .urban-content {
    padding: 30px 0 0;
  }

  .urban-content h2 {
    font-size: 25px;
    line-height: 39px;
  }

  .urb-text h3 {
    font-size: 19px;
    line-height: 30px;
  }

  .urban-row:last-child .urban-img {
    padding: 0;
  }

  .download-inner h3 {
    font-size: 25px;
    line-height: 39px;
  }

  .buttons-grp a {
    font-size: 15px;
  }

  .download-app {
    padding: 70px 0;
  }

  .opinions-section {
    padding: 40px 0 70px;
  }

  .opinions-title h3 {
    font-size: 30px;
    line-height: 49px;
  }
  .opinions-title {
    margin: 0 0 10px;
  }

  .opinions-bx {
    margin-left: 0;
    margin-right: 0;
  }

  .ctc-inner p {
    font-size: 20px;
    line-height: 24px;
  }

  .ctc-inner h3 {
    font-size: 28px;
    line-height: 38px;
  }

  .ctc-inner h4 {
    font-size: 28px;
    line-height: 39px;
  }

  .fill-button {
    font-size: 15px;
  }
  /* End Home page */
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Main/home.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd,iBAAiB;AACjB;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;EACtB,yDAA+D;AACjE;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA,qBAAqB;;AAErB,sBAAsB;AACtB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA,0BAA0B;;AAE1B,oBAAoB;AACpB;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;AACA,wBAAwB;;AAExB,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;AACA,wBAAwB;;AAExB,oBAAoB;AACpB;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;AACA,wBAAwB;;AAExB,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;EACX,yDAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA,+BAA+B;;AAE/B,kBAAkB;AAClB;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA,sBAAsB;;AAEtB,yBAAyB;AACzB;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;AACA,6BAA6B;;AAE7B,qBAAqB;AACrB;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;AACA,yBAAyB;;AAEzB,gBAAgB;AAChB;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;AACA,oBAAoB;;AAEpB,eAAe;AACf;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;AACA,cAAc;;AAEd,kBAAkB;;AAElB;EACE,cAAc;EACd;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;EACA,kBAAkB;AACpB;AACA;EACE,cAAc;EACd;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,uCAAuC;EACzC;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,kBAAkB;AACpB;AACA;EACE,cAAc;EACd;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,+CAA+C;IAC/C,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;EACA,kBAAkB;AACpB","sourcesContent":["/* Home page */\n\n/* Hero section */\n.items-slide {\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  padding: 170px 0 420px;\n  background-image: url(\"../../Assets/images/hero-banner-bg.jpg\");\n}\n.hero-inner h1 {\n  font-size: 72px;\n  color: #fff;\n  font-weight: 600;\n  margin: 0 0 30px;\n}\n.hero-slider ul.slick-dots {\n  bottom: auto;\n  right: 0;\n  width: 40px;\n  top: 50%;\n}\n\n.hero-slider .slick-dots li button:before {\n  font-size: 15px;\n  opacity: 0.5;\n  color: #5c58fc !important;\n}\n\n.hero-slider .slick-dots li.slick-active button:before {\n  opacity: 1;\n}\n.hero-main {\n  position: relative;\n}\n\n.hero-slider {\n  margin: 0 !important;\n}\n.hero-inner p {\n  font-size: 26px;\n  line-height: 38px;\n  color: #fff;\n  max-width: 620px;\n}\n\n.hero-counter {\n  background-color: #5c58ff;\n  border-radius: 12px;\n  padding: 50px 20px;\n  max-width: 1100px;\n  margin: 0 auto 0;\n  position: absolute;\n  left: 15px;\n  right: 15px;\n  bottom: 80px;\n}\n.column-3 {\n  width: 25%;\n  padding: 0 15px;\n}\n\n.hr-count {\n  text-align: center;\n}\n\n.hr-count h2 {\n  color: #fff;\n  font-size: 50px;\n  font-weight: 700;\n  line-height: 66px;\n  margin: 0 0 10px;\n}\n\n.hr-count p {\n  color: #fff;\n  font-size: 20px;\n  line-height: 31px;\n}\n/* End Hero section */\n\n/* Plateform section */\n.platform-section {\n  padding: 170px 0 85px;\n  text-align: center;\n  position: relative;\n}\n.platform-section::before {\n  content: \"\";\n  width: 4px;\n  background-color: #1e73be;\n  height: 135px;\n  position: absolute;\n  top: -15px;\n}\n.platform-inner p,\n.platform-inner h3 {\n  font-size: 30px;\n  line-height: 42px;\n  font-weight: 300;\n}\n.platform-inner {\n  max-width: 1050px;\n  margin: 0 auto;\n}\n/* End Plateform section */\n\n/* Citizen section */\n.citizen-section {\n  background-color: #4ac193;\n}\n\n.citizen-section .row {\n  margin: 0;\n}\n\n.citizen-section .col6 {\n  padding: 0;\n}\n\n.citizen-left h6 {\n  font-size: 18px;\n  line-height: 22px;\n  font-weight: 300;\n  color: #fff;\n}\n\n.citizen-left h2 {\n  font-size: 45px;\n  line-height: 55px;\n  color: #fff;\n  margin: 10px 0;\n}\n\n.citizen-left p {\n  font-size: 23px;\n  line-height: 38px;\n  color: #fff;\n  font-weight: 300;\n}\n\n.citizen-left {\n  padding: 18% 17%;\n}\n\n.citizen-right img {\n  display: block;\n  width: 100%;\n}\n\n.citizen-box {\n  background-color: #5c58fc;\n  width: 100%;\n  padding: 15px 40px;\n}\n\n.citizen-right {\n  height: 100%;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.citizen-box .row {\n  align-items: center;\n  height: 100%;\n}\n\n.citizen-bx-inner {\n  text-align: center;\n  padding: 18px 0;\n}\n\n.citizen-bx-inner p {\n  font-size: 23px;\n  line-height: 27px;\n  color: #fff;\n}\n\n.citizen-bx-inner {\n  border-right: 1px solid rgb(255 255 255 / 20%);\n}\n\n.citizen-box .col6:last-child .citizen-bx-inner {\n  border-right: none;\n}\n/* End Citizen section */\n\n/* Digital section */\n.digital-section {\n  padding: 110px 0;\n}\n\n.sc-title {\n  text-align: center;\n}\n\n.sc-title h3 {\n  font-size: 36px;\n  line-height: 47px;\n  font-weight: 400;\n  margin: 0 0 15px;\n}\n\n.sc-title p {\n  font-size: 30px;\n  line-height: 49px;\n  font-weight: 300;\n}\n\n.dil-grid {\n  text-align: center;\n  width: 33.3%;\n  padding: 15px 15px;\n  margin: 30px 0;\n}\n\n.dil-grid p {\n  font-size: 25px;\n  line-height: 40px;\n  font-weight: 300;\n}\n\n.dil-grid img {\n  width: 37px;\n  margin: 0 auto;\n}\n\n.digital-grid {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 10px 0 0;\n}\n\n.dil-grid:nth-child(4),\n.dil-grid:nth-child(5) {\n  width: 50%;\n}\n/* End Digital section */\n\n/* service section */\n.service-section .col4 {\n  padding: 0;\n}\n\n.srv-inner {\n  position: relative;\n}\n\n.srv-img img {\n  width: 100%;\n  display: block;\n}\n\n.srv-content {\n  position: absolute;\n  bottom: 100px;\n  text-align: center;\n  right: 0;\n  left: 0;\n  padding: 0 20px;\n}\n\n.srv-content h6 {\n  color: #fff;\n  font-weight: 300;\n  font-size: 12.2px;\n  text-shadow: 1px 1px rgb(0 0 0 / 50%);\n}\n\n.srv-content h3 {\n  color: #fff;\n  font-size: 30px;\n  font-weight: 400;\n  line-height: 49px;\n  margin: 10px 0 20px;\n  text-shadow: 1px 1px rgb(0 0 0 / 50%);\n}\n\n.fill-button {\n  background-color: #5c58fc;\n  color: #fff;\n  font-size: 16px;\n  letter-spacing: 0.5px;\n  padding: 10px 20px;\n  line-height: normal;\n  display: inline-block;\n  border-radius: 5px;\n}\n/* End service section */\n\n/* morden service section */\n.morden-service {\n  padding: 110px 0 0;\n}\n\n.sc-title hr {\n  width: 30px;\n  border-color: #5c58fc;\n  margin-top: 50px;\n}\n\n.morden-inner {\n  margin-top: 70px;\n}\n\n.morden-inner .row {\n  margin: 0;\n  align-items: center;\n}\n\n.morden-inner .col6 {\n  padding: 0;\n}\n\n.morden-content {\n  padding: 40px 21%;\n}\n.morden-content h2 {\n  font-size: 59px;\n  line-height: 77px;\n  position: relative;\n}\n\n.morden-img img {\n  display: block;\n  width: 100%;\n}\n.with-shape::before {\n  content: \"\";\n  background-image: url(\"../../Assets/images/border-shape.png\");\n  width: 320px;\n  height: 10px;\n  position: absolute;\n  bottom: -10px;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n/* End morden service section */\n\n/* Urban section */\n.light-grey-bg {\n  background-color: #f6f6f6;\n}\n\n.urban-service {\n  padding: 90px 0 170px;\n}\n\n.urban-title {\n  text-align: center;\n  max-width: 810px;\n  margin: 0 auto 80px;\n}\n\n.urban-title img {\n  width: 100%;\n  max-width: 467px;\n}\n\n.urban-title p {\n  font-weight: 300;\n  font-size: 25px;\n  line-height: 40px;\n  margin: 40px 0;\n}\n\n.urban-img img {\n  width: 100%;\n  display: block;\n}\n\n.urban-content h2 {\n  font-size: 31px;\n  line-height: 51px;\n  font-weight: 300;\n}\n\n.urban-content p {\n  font-size: 14px;\n  line-height: 24px;\n  margin: 12px 0;\n}\n.urban-row .row {\n  align-items: center;\n}\n.urb-rw {\n  display: flex;\n  flex-wrap: wrap;\n}\n.urban-row:first-child .urban-img {\n  margin-left: -60px;\n}\n\n.urban-row:last-child .urban-img {\n  margin-right: -60px;\n}\n.urb-text {\n  width: calc(100% - 37px);\n  padding: 0 0 0 15px;\n}\n\n.urb-icon {\n  width: 37px;\n}\n\n.urb-text h3 {\n  font-size: 24px;\n  line-height: 38px;\n  font-weight: 300;\n}\n.urban-row {\n  margin: 0 0 30px;\n}\n\n.urban-img {\n  padding-right: 10px;\n}\n/* End Urban section */\n\n/* Download app section */\n.download-app {\n  padding: 90px 0;\n}\n\n.download-inner {\n  text-align: center;\n}\n\n.download-inner h3 {\n  font-size: 33px;\n  line-height: 53px;\n  font-weight: 300;\n  margin: 0 0 15px;\n}\n\n.buttons-grp {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.buttons-grp a {\n  margin: 0 5px;\n  padding: 13px 25px;\n  border-radius: 5px;\n}\n\n.dark-grey-btn {\n  background-color: #4c4c4c;\n}\n/* End Download app section */\n\n/* Opinions section */\n.green-bg {\n  background-color: #4ac193;\n}\n\n.opinions-section {\n  padding: 140px 0;\n}\n\n.opinions-title {\n  text-align: center;\n  margin: 0 0 40px;\n}\n\n.opinions-title h3 {\n  color: #fff;\n  font-weight: 300;\n  font-size: 39px;\n  line-height: 63px;\n}\n\n.opinions-title p {\n  color: #fff;\n}\n\n.opinions-bx {\n  background-color: #fff;\n  border-radius: 20px;\n  padding: 25px;\n  margin: 15px;\n  width: 34%;\n}\n\n.opinions-bx img {\n  width: 82px;\n}\n\n.opinions-bx p {\n  font-size: 16px;\n  line-height: 22px;\n  font-style: italic;\n}\n\n.opinions-inner {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.opinions-bx:nth-child(3),\n.opinions-bx:nth-child(4) {\n  width: 41%;\n}\n\n.opinions-bx:last-child {\n  width: 45%;\n}\n/* End Opinions section */\n\n/* CTC section */\n.ctc-section {\n  background-color: #5c58fc;\n  padding: 65px 0;\n}\n\n.ctc-inner {\n  text-align: center;\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.ctc-inner p {\n  color: #fff;\n  font-size: 25px;\n  line-height: 33px;\n  font-weight: 300;\n  margin: 0 0 40px;\n}\n\n.ctc-inner h3 {\n  color: #fff;\n  font-size: 43px;\n  line-height: 56px;\n}\n.ctc-inner h4 {\n  font-size: 34px;\n  line-height: 45px;\n  color: #fff;\n  margin: 0 0 40px;\n}\n\n.ctc-inner a {\n  background-color: #fff;\n  color: #666666;\n  font-size: 18px;\n  padding: 16px 36px;\n  display: inline-block;\n  border-radius: 50px;\n  vertical-align: middle;\n}\n.ctc-inner a img {\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0 0 0 8px;\n  position: relative;\n  top: -2px;\n}\n/* End CTC section */\n\n/*News section*/\n.news-section {\n  padding: 80px 0;\n}\n\n.news-title {\n  text-align: center;\n  margin: 0 0 50px;\n}\n\n.news-title h2 {\n  position: relative;\n  font-size: 38px;\n  line-height: 50px;\n}\n\n.news-title h2::before {\n  content: \"\";\n  background-color: rgb(4 4 4 / 10%);\n  height: 1px;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 52%;\n  transform: translateY(-50%);\n}\n\n.news-title h2 span {\n  background-color: #fff;\n  padding: 0 10px;\n  position: relative;\n  z-index: 1;\n}\n/*end of news*/\n\n/* End Home page */\n\n@media only screen and (max-width: 1440px) {\n  /* Home page */\n  .hero-inner h1 {\n    font-size: 58px;\n  }\n\n  .hero-inner p {\n    font-size: 22px;\n    line-height: 32px;\n    max-width: 520px;\n  }\n\n  .hr-count h2 {\n    font-size: 42px;\n    line-height: 58px;\n  }\n\n  .hr-count p {\n    font-size: 18px;\n    line-height: 29px;\n  }\n\n  .platform-inner p,\n  .platform-inner h3 {\n    font-size: 24px;\n    line-height: 36px;\n  }\n\n  .citizen-left h6 {\n    font-size: 16px;\n    line-height: 20px;\n  }\n\n  .citizen-left h2 {\n    font-size: 40px;\n    line-height: 50px;\n  }\n\n  .citizen-left p {\n    font-size: 20px;\n    line-height: 33px;\n  }\n\n  .sc-title h3 {\n    font-size: 30px;\n    line-height: 41px;\n  }\n\n  .sc-title p {\n    font-size: 24px;\n    line-height: 38px;\n  }\n\n  .dil-grid p {\n    font-size: 22px;\n    line-height: 36px;\n  }\n\n  .srv-content h3 {\n    font-size: 24px;\n    line-height: 30px;\n  }\n\n  .srv-content {\n    bottom: 60px;\n  }\n\n  .morden-content h2 {\n    font-size: 50px;\n    line-height: 68px;\n  }\n\n  .with-shape::before {\n    width: 270px;\n  }\n\n  .urban-title p {\n    font-size: 22px;\n    line-height: 36px;\n  }\n\n  .urban-title img {\n    max-width: 367px;\n  }\n\n  .urban-row:first-child .urban-img {\n    margin: 0;\n  }\n\n  .urban-row:last-child .urban-img {\n    margin: 0;\n  }\n\n  .ctc-inner p {\n    font-size: 22px;\n    line-height: 30px;\n  }\n\n  .ctc-inner h3 {\n    font-size: 36px;\n    line-height: 50px;\n  }\n\n  .ctc-inner h4 {\n    font-size: 30px;\n    line-height: 41px;\n  }\n\n  .ctc-inner a {\n    font-size: 16px;\n  }\n  /* End Home page */\n}\n@media only screen and (max-width: 991px) {\n  /* Home page */\n  .items-slide {\n    padding: 170px 0 280px;\n  }\n\n  .hero-counter {\n    padding: 30px 15px;\n    bottom: 50px;\n  }\n\n  .items-slide {\n    background-position: right -90px center;\n  }\n  .platform-section {\n    padding: 150px 30px 70px;\n  }\n\n  .citizen-section .col6 {\n    width: 100%;\n  }\n\n  .citizen-left {\n    padding: 15% 16%;\n  }\n  .citizen-box .col6 {\n    width: 50%;\n  }\n\n  .srv-img img {\n    object-fit: cover;\n    height: 550px;\n  }\n\n  .morden-inner .col6 {\n    width: 100%;\n  }\n\n  .morden-inner .row {\n    flex-direction: column-reverse;\n  }\n\n  .morden-content {\n    padding: 60px 15%;\n  }\n\n  .urban-title img {\n    max-width: 311px;\n  }\n\n  .urban-row .col6 {\n    width: 100%;\n  }\n\n  .urban-content {\n    padding: 30px 11% 0;\n  }\n\n  .urb-icon {\n    width: 33px;\n  }\n\n  .urb-text {\n    width: calc(100% - 33px);\n  }\n\n  .urban-row {\n    margin: 0 0 0;\n  }\n\n  .urban-row:last-child .urban-img {\n    padding-left: 11%;\n    margin-top: 30px;\n  }\n\n  .opinions-bx {\n    width: 100% !important;\n    max-width: 450px;\n  }\n\n  .opinions-section {\n    padding: 100px 0;\n  }\n\n  .opinions-title h3 {\n    margin: 0 0 10px;\n  }\n\n  /* End Home page */\n}\n@media only screen and (max-width: 767px) {\n  /* Home page */\n  .hero-counter {\n    display: none;\n  }\n\n  .items-slide {\n    padding: 150px 0 50px;\n    background-position: right 0px center;\n  }\n\n  .hero-inner p {\n    max-width: 100%;\n    font-size: 18px;\n    line-height: 24px;\n  }\n\n  .hero-inner h1 {\n    font-size: 50px;\n    line-height: 50px;\n    margin: 0 0 15px;\n  }\n  .citizen-left {\n    padding: 50px 30px;\n  }\n\n  .citizen-left h2 {\n    font-size: 36px;\n    line-height: 46px;\n  }\n\n  .citizen-left p {\n    font-size: 18px;\n    line-height: 29px;\n  }\n\n  .citizen-box .col6 {\n    width: 100%;\n  }\n\n  .citizen-bx-inner {\n    border-bottom: 1px solid rgb(255 255 255 / 20%);\n    border-right: none;\n    padding: 20px 0;\n  }\n\n  .citizen-box .col6:last-child .citizen-bx-inner {\n    border-bottom: none;\n  }\n\n  .citizen-box {\n    padding: 15px 20px;\n  }\n\n  .citizen-bx-inner p {\n    font-size: 18px;\n    line-height: 22px;\n  }\n\n  .digital-section {\n    padding: 60px 0;\n  }\n\n  .sc-title h3 {\n    font-size: 28px;\n    line-height: 37px;\n  }\n\n  .sc-title p {\n    font-size: 20px;\n    line-height: 32px;\n  }\n\n  .dil-grid {\n    width: 100% !important;\n    margin: 20px 0;\n  }\n\n  .dil-grid p {\n    font-size: 20px;\n    line-height: 32px;\n  }\n\n  .digital-grid {\n    margin-top: 20px;\n  }\n\n  .service-section .col4 {\n    width: 100%;\n  }\n\n  .morden-service {\n    padding: 70px 0 0;\n  }\n\n  .morden-content {\n    padding: 60px 30px;\n  }\n\n  .morden-content h2 {\n    font-size: 45px;\n    line-height: 63px;\n  }\n\n  .urban-title img {\n    max-width: 186px;\n  }\n\n  .urban-service {\n    padding: 70px 0 100px;\n  }\n\n  .urban-title p {\n    font-size: 19px;\n    line-height: 30px;\n  }\n\n  .urban-content {\n    padding: 30px 0 0;\n  }\n\n  .urban-content h2 {\n    font-size: 25px;\n    line-height: 39px;\n  }\n\n  .urb-text h3 {\n    font-size: 19px;\n    line-height: 30px;\n  }\n\n  .urban-row:last-child .urban-img {\n    padding: 0;\n  }\n\n  .download-inner h3 {\n    font-size: 25px;\n    line-height: 39px;\n  }\n\n  .buttons-grp a {\n    font-size: 15px;\n  }\n\n  .download-app {\n    padding: 70px 0;\n  }\n\n  .opinions-section {\n    padding: 40px 0 70px;\n  }\n\n  .opinions-title h3 {\n    font-size: 30px;\n    line-height: 49px;\n  }\n  .opinions-title {\n    margin: 0 0 10px;\n  }\n\n  .opinions-bx {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  .ctc-inner p {\n    font-size: 20px;\n    line-height: 24px;\n  }\n\n  .ctc-inner h3 {\n    font-size: 28px;\n    line-height: 38px;\n  }\n\n  .ctc-inner h4 {\n    font-size: 28px;\n    line-height: 39px;\n  }\n\n  .fill-button {\n    font-size: 15px;\n  }\n  /* End Home page */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
